import React from "react";
import { Box, Container } from "@mui/material";

export default function LogoLeiste() {
  const logos = [
    {
      name: "DER STANDARD",
      src: "https://commons.wikimedia.org/wiki/Special:FilePath/DER%20STANDARD%20LOGO%20schwarz.svg",
    },
    { name: "PULS 4", src: "https://commons.wikimedia.org/wiki/Special:FilePath/Puls%204%20Logo.svg" },
    { name: "SWR2", src: "https://commons.wikimedia.org/wiki/Special:FilePath/SWR2%20Logo.svg" },
    {
      name: "Radio Arabella",
      src: "https://commons.wikimedia.org/wiki/Special:FilePath/Radio%20Arabella%20Logo%20(2022).svg",
    },
    { name: "ORF", src: "https://commons.wikimedia.org/wiki/Special:FilePath/ORF%20logo.svg" },
    { name: "Thalia", src: "https://commons.wikimedia.org/wiki/Special:FilePath/Thalia%20Logo%2010.2019.svg" },
    { name: "KURIER", src: "https://commons.wikimedia.org/wiki/Special:FilePath/Kurier%20Logo.svg" },
    { name: "Die Presse", src: "https://commons.wikimedia.org/wiki/Special:FilePath/Die%20Presse%20logo.svg" },
    { name: "ZDF", src: "https://commons.wikimedia.org/wiki/Special:FilePath/ZDF%20logo.svg" },
  ];

  return (
    <Box component="section" aria-label="Partner & Presse" sx={{ py: { xs: 2, md: 2 } }}>
      {/* Optional: wenn du eh schon in einem <Container> bist, kannst du den Container hier entfernen */}
      <Container maxWidth="lg">
<Box
  role="img"
  aria-label="Logoleiste"
  sx={{
    width: "100%",

    // ✅ Mobile: 3 pro Zeile
    // ✅ Desktop: 1 Zeile mit allen Logos
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(3, minmax(0, 1fr))",
      md: `repeat(${logos.length}, minmax(0, 1fr))`,
    },

    // ✅ Nur zwischen Icons (kein Rand-gap)
    // space-between Effekt im Grid:
    justifyContent: "space-between",
    columnGap: { xs: 2.2, md: 3.2 },
    rowGap: { xs: 2.0, md: 0 },

    alignItems: "center",
  }}
>
  {logos.map((l) => (
    <Box
      key={l.name}
      sx={{
        display: "flex",
        alignItems: "center",

        // ✅ erste Spalte links, letzte rechts, mittlere mittig
        justifyContent: {
          xs: "center",
          md: "center",
        },

        minWidth: 0,
      }}
    >
      <Box
        component="img"
        src={l.src}
        alt={l.name}
        loading="lazy"
        sx={{
          height: { xs: 13, sm: 13, md: 20 },
          width: "auto",
          maxWidth: "100%",
          opacity: 0.82,
          filter: "grayscale(1)",
          transition: "opacity 160ms ease, filter 160ms ease, transform 160ms ease",
          "&:hover": {
            opacity: 1,
            filter: "grayscale(0)",
            transform: "translateY(-1px)",
          },
        }}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    </Box>
  ))}
</Box>


      </Container>
    </Box>
  );
}
